import { Link } from "react-router-dom";
import { AgencyLogo } from "@/components/agency-logo";

export function VantaIntegrationPage() {
  return (
    <div className="relative flex min-h-screen items-center justify-center bg-background overflow-hidden">
      <div className="login-grid" />
      <div className="login-glow" />

      <div className="relative z-10 w-full max-w-lg rounded-2xl border border-border/60 bg-surface/90 p-8 shadow-elevated backdrop-blur-sm">
        <div className="mb-8 flex flex-col items-center gap-4">
          <AgencyLogo className="h-8 text-text-primary" />
          <p className="text-[10px] font-medium uppercase tracking-[0.25em] text-text-muted">
            Vanta Integration
          </p>
        </div>

        <div className="space-y-5 text-sm text-text-secondary">
          <p>
            AgencyMDR connects with Vanta to automatically push your device inventory
            for compliance reporting. Once authorized, your macOS and Windows devices
            and user accounts will stay in sync with Vanta.
          </p>

          <div className="space-y-3">
            <h2 className="text-xs font-medium uppercase tracking-wider text-text-muted">How to connect</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>Sign in to your AgencyMDR account.</li>
              <li>Navigate to your tenant's <span className="font-medium text-text-primary">Settings</span> page.</li>
              <li>Click <span className="font-medium text-text-primary">Connect Vanta</span> in the Vanta Integration card.</li>
              <li>Authorize AgencyMDR in the Vanta prompt.</li>
              <li>You're connected — push devices manually or enable auto-push.</li>
            </ol>
          </div>

          <Link
            to="/login"
            className="mt-2 block w-full rounded-lg bg-accent px-4 py-2.5 text-center text-sm font-medium text-white hover:bg-accent/90 transition-colors"
          >
            Sign In to Get Started
          </Link>
        </div>
      </div>
    </div>
  );
}
